
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorPiston25 as ObiTwowayAcuatorPiston25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-piston-25.js';
 
 
 

 
 export const ObiTwowayAcuatorPiston25 = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-piston-25',
   elementClass: ObiTwowayAcuatorPiston25Element,
   events: {
     
   }
  });
 
 